<div class="item__desc">
  {{ imageDescription$ | async }}
</div>

<div class="item__params">
  <div>
    <div>Views:</div>
    <div>{{ imageViews$ | async | number }}</div>
  </div>
  <div>
    <div>Downloads:</div>
    <div>{{ imageDownloads$ | async | number }}</div>
  </div>
  @if (imageLocation$ | async; as imageLocation) {
    <div>
      <div>Location:</div>
      <div>{{ imageLocation }}</div>
    </div>
  }
  <div>
    <div>License:</div>
    <div>
      <a class="license" href="/licensing-policy" target="_blank"
        >Licensing Policy</a
      >
    </div>
  </div>
  <div>
    <div>Camera:</div>
    <div>{{ imageCamera$ | async }}</div>
  </div>
  @defer {
    <app-item-share />
  }
</div>
